import PrivacyCluster from "../enums/PrivacyCluster";

class GigyaManager {

	constructor() {
		this.gigyaSdkReadyPromise = new Promise((resolve) => {
			if (!window.gigya) {
				if (!window.checkIntervalFette) {
					window.checkIntervalFette = setInterval(function () {
						if (window.gigya) {
							clearInterval(window.checkIntervalFette);
							resolve();
						}
					}, 500);
				}
			} else {
				return resolve();
			}
		});

		this.getLoggedUserPromise = this.getLoggedUser();
	}

	getLoggedUser() {
		return new Promise((resolve, reject) => {
			this.isGigyaSdkReady().then(() => {
				window.gigya.accounts.getAccountInfo({
					callback: (data) => {
						if (data.status == "OK") {
							resolve(data);
						} else {
							reject(data);
						}
					},
					include:"profile,data,preferences"
				});
			})
		});
	}

	getLoggedUserCached(){
		return this.getLoggedUserPromise;
	}

	getJWT() {
		return new Promise((resolve, reject) => {
			this.isGigyaSdkReady().then(() => {
				window.gigya.accounts.getJWT({
					callback: (data) => {
						if (data.status == "OK") {
							resolve(data);
						} else {
							reject(data);
						}
					}
				});
			})
		});
	}


	isGigyaSdkReady() {
		return this.gigyaSdkReadyPromise;
	}

	getPrivacyCluster() {
		return new Promise((resolve) => {
			this.getLoggedUser().then((account) => {
				let PRIVACY_PROFILING = window.SCREENSETS_VERSION > 3 ? account.preferences.privacy_profiling.isConsentGranted : account.data.PRIVACY_PROFILING == 'true';
				let GIGYA_PRIVACY_RECALL =  window.SCREENSETS_VERSION > 3 ? account.preferences.privacy_recall.isConsentGranted : account.data.PRIVACY_RECALL;
				let PRIVACY_RECALL = GIGYA_PRIVACY_RECALL && (!account.data.OPTOUT_BRAND || account.data.OPTOUT_BRAND.indexOf("BR_mulinobianco") == -1);

				if (!PRIVACY_PROFILING && !PRIVACY_RECALL) {
					resolve(PrivacyCluster.U1);
				} else if (PRIVACY_PROFILING && !PRIVACY_RECALL) {
					resolve(PrivacyCluster.U2);
				} else if (!PRIVACY_PROFILING && PRIVACY_RECALL) {
					resolve(PrivacyCluster.U3);
				} else {
					resolve(PrivacyCluster.U4);
				}
			}, () => {
				resolve(PrivacyCluster.U5)
			});
		});
	}

	addCH(chName){
		return new Promise((res, err)=>{
			var d = new Date();
			var m = d.getMonth() + 1;
			var month = (m + "").length > 1 ? m : "0" + m;
			var fullstr = d.getFullYear() + "-" + month + "-" + d.getDate();
			var data = {};
			data[chName] = fullstr;
			this.setAccountInfo({data:data, callback: (d) => {
				if(d.status == "OK"){
					res(true);
				}else{
					err(false);
				}
			}});
		});
	}

	removeCH(chName){
		return new Promise((res, err)=>{
			var data = {};
			data[chName] = null;
			this.setAccountInfo({data:data, callback: (d) => {
				if(d.status == "OK"){
					res(true);
				}else{
					err(false);
				}
			}});
		});
	}

	setAccountInfo(params){
		this.isGigyaSdkReady().then(() => {
			window.gigya.accounts.setAccountInfo(params);
		})
	}


	logout() {
		return new Promise((resolve) => {
			this.isGigyaSdkReady().then(() => {
				window.gigya.accounts.logout({
					callback: () => {
						resolve();
					}
				});
			})
		});
	}
}

export default new GigyaManager();
